import { useEffect } from 'react';

/**
 * Custom hook to lock/unlock body scroll when a modal or popup is open
 * @param isOpen - Whether the modal/popup is open
 */
export const useScrollLock = (isOpen: boolean) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    // Cleanup on unmount
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);
};